/**
 * Created by sunshine on 2016/12/14.
 */
import Vue from 'vue'
import VueResource from 'vue-resource'
import engineering from './engineering'
// Resource
Vue.use(VueResource)
new Vue({
  el: '#app',
  template: '<engineering/>',
  components: { engineering }
})



// WEBPACK FOOTER //
// ./src/pages/engineering/index.js